// extracted by mini-css-extract-plugin
module.exports = {"NumericValue":"NumericValue--35NXk","Text":"Text--28lRJ","Unit":"Unit--26sy7","Highlighted":"Highlighted--3-lBU"};